import "../../CommonImports";
import "../../Core/core.css";
import "./Tabs.css";
import * as React from "react";
import { ObservableArray } from '../../Core/Observable';
import { TabProviderContext, TabProvider } from "./TabProviderContext";
/**
 * Hooks into tab provider context to render the tab's provided content, as well
 * as optionally the a filter bar if it is to be rendered outside of the TabBar.
 */
export class TabContent extends React.Component {
    render() {
        return (React.createElement(TabProviderContext.Consumer, null, (tabProviderContext) => {
            let content;
            if (tabProviderContext.renderContent) {
                const filterBar = tabProviderContext.renderFilterBar && tabProviderContext.renderFilterBar(false);
                content = (React.createElement(React.Fragment, null,
                    filterBar,
                    tabProviderContext.renderContent()));
            }
            else {
                content = React.createElement(React.Fragment, null, this.props.children);
            }
            return (React.createElement(TabProvider, { providers: new ObservableArray([]), selectedTabId: tabProviderContext.selectedId || "" }, content));
        }));
    }
}
